import { Subnav } from '@driftt/tide-subnav'
import React, { useState } from 'react'

import { APP_PAGE_TITLES } from 'constants/pageTitles'
import useDocumentTitle from 'hooks/usePageTitle'
import { userHasAnyPlaybookAccess } from 'utils/access'
import { getSubNavNodes } from 'utils/getSubNavNodes'

const PlaybookPageLayout = ({
  children,
  pageTitle,
}: {
  children: React.ReactNode
  pageTitle: typeof APP_PAGE_TITLES[keyof typeof APP_PAGE_TITLES]
}) => {
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false)
  const hasAnyPlaybookAccess = userHasAnyPlaybookAccess()
  useDocumentTitle(pageTitle)

  const SUB_NAV_NODES = getSubNavNodes()
  return (
    <>
      {hasAnyPlaybookAccess && (
        <Subnav
          title="Chatbot"
          nodes={SUB_NAV_NODES}
          open={sidebarIsOpen}
          onToggle={() => setSidebarIsOpen(!sidebarIsOpen)}
        />
      )}
      {children}
    </>
  )
}

export default PlaybookPageLayout
